// Utility for driver duty overlap detection

/**
 * Detects overlapping rows in a shiftbat (ignoring notes, stops, etc)
 * @param {Array} rows
 * @returns {{filteredRows: Array, overlappingRowIds: Set}}
 */
export function detectDutyOverlaps(rows) {
    // Filter to only include types we want to display
    const ShiftBatRowType = rows[0]?.constructor?.ShiftBatRowType || {};
    const filteredRows = rows.filter(row => ![
        ShiftBatRowType.noteTimed, 
        ShiftBatRowType.note, 
        ShiftBatRowType.location, 
        ShiftBatRowType.stop, 
        ShiftBatRowType.stopNote, 
        ShiftBatRowType.template
    ].includes(row.type));
    // Sort rows by start time
    const sortedRows = [...filteredRows].sort((a, b) => {
        const aTime = a.getTime?.() || 0;
        const bTime = b.getTime?.() || 0;
        return aTime - bTime;
    });
    // Mark overlapping rows
    const overlappingRowIds = new Set();
    for (let i = 0; i < sortedRows.length; i++) {
        const currentRow = sortedRows[i];
        const currentStartTime = currentRow.getTime?.() || 0;
        const currentEndTime = currentRow.getEndTime?.() || 0;
        for (let j = i + 1; j < sortedRows.length; j++) {
            const nextRow = sortedRows[j];
            const nextStartTime = nextRow.getTime?.() || 0;
            const nextEndTime = nextRow.getEndTime?.() || 0;
            if (nextStartTime < currentEndTime) {
                overlappingRowIds.add(currentRow.id);
                overlappingRowIds.add(nextRow.id);
            }
        }
    }
    return {
        filteredRows,
        overlappingRowIds
    };
} 